export const SUPPORTED_MAX_BULK_JOB_SELECTION_COUNT = 5000;
